<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานการเปลี่ยนแปลงอัตราค่าบริการเฉลี่ยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link to="/Admin/Services_change">
            <i class="fa fa-dashboard"></i> รายงานการเปลี่ยนแปลงอัตราค่าบริการเฉลี่ยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล
          </router-link>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <el-option label="รายเดือน" value="month"></el-option>
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ประเภทผู้ให้บริการ">
                            <el-radio-group v-model="form.type_providers" @change="compareType" >
                              <el-radio  label="group">กลุ่มผู้ให้บริการ</el-radio>
                              <el-radio  label="provider">รายชื่อผู้ให้บริการ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="กลุ่มผู้ให้บริการ" :required="cType">
                            <el-radio-group v-model="form.provider_group" :disabled="!cType">
                              <el-radio 
                                ref="provider_group"
                                v-for="group in this.store_groups" 
                                :key="group.id" 
                                :label="group">
                                {{group.group_name_th}}
                              </el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="รายชื่อผู้ให้บริการ" :required="!cType">
                            <el-radio-group v-model="form.provider_list" :disabled="cType">
                              <el-radio 
                                ref="provider_list"
                                v-for="provider in this.store_providers" 
                                :key="provider.id" 
                                :label="provider">
                                {{provider.brand_name}}
                              </el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="แสดงกราฟแท่งอัตราค่าบริการเฉลี่ยของตลาดแบบถ่วงน้ำหนัก">
                            <el-radio-group v-model="form.weighting">
                              <el-radio :label="1">แสดง</el-radio>
                              <el-radio :label="0">ไม่แสดง</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.type_report === ''"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            default-value="2556"
                            v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="monthfrom"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              ref="quarter_year_from"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ประเภทชนิดบริการ">
                            <el-select v-model="form.service_type">
                              <el-option label="ชนิดบริการทั้งหมด" value=""></el-option>
                              <el-option label="เสียง" value="Voice"></el-option>
                              <el-option label="SMS" value="SMS"></el-option>
                              <el-option label="MMS" value="MMS"></el-option>
                              <el-option label="Internet" value="Internet"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ย่านความถี่">
                            <el-radio-group v-model="form.frequency">
                              <el-radio label="900">900 MHz</el-radio>
                              <el-radio label="1800">1800 MHz</el-radio>
                              <el-radio label="2100">2.1 GHz</el-radio>
                              <el-radio label="other">อื่นๆ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                              <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                          <el-form-item label="อัตราที่กำกับดูแล" required>
                            <el-radio-group v-model="form.regulator">
                              <el-radio v-for="item in service_rate_regulate" :key="item.id" :label="item">{{item.service_name}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                    </div>
                    </el-form>
                  </div>
                  <div v-if="displayChart&&showChart">
                    <div class="col-sm-12" style="text-align:right;">
                      <el-button type='primary' @click.prevent="exportDoc" v-loading="pending">Export Word </el-button>
                    </div>
                  </div>
                  <div id="chart" class="box-body" ref="chart" v-if="displayChart&&showChart">
                    <!-- <div class="col-sm-12" style="padding-top: 50px;"  ref="data">
                      <charts class="chart" :options="this.store_charts" style="max-height: 400px;"></charts><br><br>
                    </div> -->
                    <div class="col-sm-12" v-for="chart in this.store_charts" :key="chart.id">
                      <charts class="chart" style="max-height : 400px;" :options="chart" ></charts>
                    </div>
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style>
.custom {
  width: 100%;
  margin-top: 30px;
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
}

.custom td,
.custom th {
  padding: 8px;
  border: 1px solid #ddd;
}

.custom th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
</style>
<script>
const moment = require("moment");
import Chart from "chart.js";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom } from "docx";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      displayChart :false,
      dynamicDiv: null,
      mixedChart: null,
      showLabel: "",
      label_position: "top",
      cType: true,
      form: {
        service_status: ['S','U','CS','CU'],
        type_providers: "group",
        frequency: "2100",
        type_data: {
          quarterfrom: "",
          quarterto: "",
          yearfrom: "",
          yearto: "",
          monthto: "",
          monthfrom: "",
          month: "",
          year: "",
          quarter: "",
          quarter_year_from: "",
          quarter_year: "",
          regulator: null
        },
        provider_group: [],
        provider_list: [],
        weighting: 0,
        service_type: "",
        type_report: "",
        year: "",
        quarter: ""
      },
      options: {
        pieceLabel: {
          render: function(args) {
            return args.label + " " + args.value + "%";
          },
          overlap: true,
          fontSize: 14,
          fontStyle: "bold",
          fontColor: "#FFF"
        }
      },
      data: {},
      pending: false
    };
  },
  mounted() {},
  beforeCreate(){
    this.$store.dispatch('Report_pmt/getGroupCompany','mobile')
    this.$store.dispatch('Report_pmt/getProviderByType','mobile')
    this.$store.dispatch('Report_SC/setServiceRateList')
  },
  computed: {
    ...mapState({
      store_charts : store => store.Report_SC.charts,
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      showChart : store => store.Report_SC.showChart,
      showDataNotFound: store => store.Report_SC.showDataNotFound,
      loading : store => store.Report_SC.loading,
      service_rate_regulate : store => store.Report_SC.service_rate_regulate
    })
  },
  methods: {
    ...mapActions({
      searching : 'Report_SC/setChartData',
      all_service_search: 'Report_SC/setAllServiceChart',
      one_service_search: 'Report_SC/setOneServiceChart'
    }),
    clear_data() {
      this.form.type_data = {
        quarterfrom: "",
        quarterto: "",
        yearfrom: "",
        yearto: "",
        monthfrom: "",
        monthto: "",
        month: "",
        year: "",
        quarter: "",
        quarter_year_from: "",
        quarter_year: ""
      };
    },
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.provider_list = []
      }else{
        this.form.provider_group = []
      }
    },
    find_chart() {
       // เช็คการเลือกประเภทรายงาน
      if (this.form.type_report == "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      } else if (this.form.type_report === "month" && this.form.type_data.month == "") {
        this.$alert("กรุณาเลือกเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
      } else if (this.form.type_report === "between_month" && (this.form.type_data.monthfrom == "" || this.form.type_data.monthto == "")) {
        this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      } else if (this.form.type_report === "between_month" && (this.form.type_data.monthfrom > this.form.type_data.monthto)){
        this.$alert("เดือนเริ่มต้นไม่ควร ไม่ควรมากกว่า เดือนสิ้นสุด", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
              this.$refs.monthfrom.focus();
          }
        });
      } else if (this.form.type_report === "year" && this.form.type_data.year == "") {
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
      } else if (this.form.type_report === "between_year" && (this.form.type_data.yearfrom == "" || this.form.type_data.yearto == "")) {
        this.$alert("กรุณาเลือกระหว่างปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
      } else if (this.form.type_report === "between_year" && (this.form.type_data.yearfrom > this.form.type_data.yearto)) {
        this.$alert("ปีเริ่มต้น ไม่ควรมากกว่า ปี่ที่สิ้นสุด", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
              this.$refs.yearfrom.focus();
          }
        });
      } else if (this.form.type_report === "quarter" && (this.form.type_data.quarter == "" || this.form.type_data.quarter_year.length == "")) {
        this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if (this.form.type_report === "between_quarter" && (this.form.type_data.quarterfrom == "" || this.form.type_data.quarterto == "" || this.form.type_data.quarter_year_from == "" || this.form.type_data.quarter_year == "")) {
        this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom == "") {
              this.$refs.quarterfrom.focus();
            }else if (this.form.type_data.quarter_year_from == ""){
              this.$refs.quarter_year_from.focus();
            }else if (this.form.type_data.quarterto == "") {
              this.$refs.quarterto.focus();
            }else if (this.form.type_data.quarter_year == ""){
              this.$refs.quarter_year.focus();
            }
          }
        });
      } else if ( this.form.type_providers == 'group' && this.form.provider_group.length == 0) {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
      } else if ( this.form.type_providers == 'provider' && this.form.provider_list.length == 0) {
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
      } else if (this.form.regulator == null || this.form.regulator == '') {
        this.$alert("กรุณาเลือกอัตรากำกับดูแล", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
      } else {
        this.displayChart = true
        let formdata = this.form
        if(formdata.service_type == ''){
          this.all_service_search(formdata)
        }else{
          this.one_service_search(formdata)
        }
        
        
      }
    },
    exportFile(com){
      if(com=="doc"){
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
            "xmlns:w='urn:schemas-microsoft-com:office:word' "+
            "xmlns='http://www.w3.org/TR/REC-html40'>"+
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header+document.getElementById("data").innerHTML+footer;
        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Report.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
      }
    },
    generatePDF(dname) {
      var doc = new jsPDF("landscape");
      doc.internal.scaleFactor = 1.8;
      this.$html2canvas(this.$refs[dname], { canvas: null }).then(function(
        canvas
      ) {
        const img = canvas.toDataURL("image/png", 1.0);
        doc.addImage(img, "JPEG", 10, 10, 280, 150);
        doc.save("Report.pdf");
      });
    },
    async exportDoc(){
      if(this.pending) return false
      this.pending = true
      let img_list = []
      let img_ratio = []
      let chart_list = document.querySelectorAll('.chart');
      for(let i = 0; i < chart_list.length; i++) {
        await this.$html2canvas(chart_list[i], {
          canvas: null,
          onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          }
        }).then(function(cv) {
          console.log(cv)
        });
        await this.$html2canvas(chart_list[i], {
          canvas: null,
          onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          }
        }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          img_list.push(img)
          img_ratio.push(canvas.height/canvas.width)
        });
      }
      const doc = new Document();
      for(let j = 0; j < img_list.length; j++) {
        let width = 920
        const image = Media.addImage(doc, img_list[j], width, width*img_ratio[j],{
          floating: {
            verticalPosition: {
              relative: VerticalPositionRelativeFrom.PAGE,
              offset: 2014400,
            },
            horizontalPosition: {
              align: HorizontalPositionAlign.CENTER
            }
          }
        });
        doc.addSection({
          size: {
            orientation: PageOrientation.LANDSCAPE,
          },
          children: [new Paragraph(image)]
        });
      }
      Packer.toBlob(doc).then(blob => {
        saveAs(blob, "report.docx");
      })
      .then(()=>{
        this.pending = false
      })
    }
  }
};
</script>
